module.exports = __webpack_public_path__ + "static/media/SIDlogo.f40cd6d8.png";